import { makeProfileRoute, Profile, WithId } from "@rooted/shared";
import React from "react";
import { Link } from "react-router-dom";

export const ProfileLink: React.FC<{ to: WithId<Profile> }> = ({ to, children }) => {
  return <Link to={makeProfileRoute(to)}>{children}</Link>;
};
